module.exports = new __parcel__URL__("crystalblast.1199c4c5.png").toString();